import { ReceiptCheck } from "./receipt-check";

export interface ReceiptItem {
  nItem?: string;
  reference: string;
  code: string;
  name: string;
  amount: number;
  unit: string;
  batchControl?: boolean;
  batch?: string;
  insertBatchLater?: boolean;
  checkedAt?: string;
  amountChecked?: number;
  nf?: string;
  registered?: boolean;
}

export interface ShippingCompany {
  CNPJ: string;
  name: string;
  truckPlate?: string;
}

export interface ReceiptNF {
  reference: string;
  number: string;
  dateOfIssue: string;
  supplier: string;
  supplierCnpj: string;
  items: ReceiptItem[];
  shippingCompanyCnpj: string;
  shippingCompany: string;
  truckPlate?: string;
}

export enum ReceiptStatus {
  notChecked = "NOT_CHECKED",
  checked = "CHECKED",
  missingProduct = "MISSING_PRODUCT",
  unexpectedProduct = "UNEXPECTED_PRODUCT",
  pending = "PENDING",
}

export interface Receipt {
  id?: number;
  name: string;
  nfs: ReceiptNF[];
  date: string;
  status?: ReceiptStatus;
  receiptCheck?: ReceiptCheck;
  warehouseId: number;
}
